import Vue from 'vue'
import Router from 'vue-router'
import {
	sources
} from '@/utils/api'
import config from 'config'
import login from '@/pages/login'
import home from '@/pages/home'
import prolist from '@/pages/prolist'
import news from '@/pages/news'
import search from '@/pages/search'

Vue.use(Router)

var router = new Router({
	mode: 'history',
	base: '/ehtsec/mall/',
	routes: [{
		path: '/',
		name: 'home',
		component: home
	},
	{
		path: '/product',
		name: 'prolist',
		component: prolist
	},
	{
		path: '/news',
		name: 'news',
		component: news
	},
	{
		path: '/search',
		name: 'search',
		component: search
	},
	{
		path: '/login',
		name: 'login',
		component: login
	},
	{
		path: '/funddetail/:id',
		name: 'funddetail',
		component: r =>
			require.ensure(
				[],
				() => r(require('@/pages/funddetail.vue')),
				'funddetail'
			)
	},
	{
		path: '/finadetail/:id',
		name: 'finadetail',
		component: r =>
			require.ensure(
				[],
				() => r(require('@/pages/finadetail.vue')),
				'finadetail'
			)
	},
	{
		path: '/fundnoticedetail',
		name: 'fundnoticedetail',
		component: r =>
			require.ensure(
				[],
				() => r(require('@/pages/fundnoticedetail.vue')),
				'fundnoticedetail'
			)
	},
	{
		path: '/fundbox',
		name: 'fundbox',
		component: r =>
			require.ensure(
				[],
				() => r(require('@/pages/fundbox.vue')),
				'fundbox'
			)
	}
	]
})

router.beforeEach((to, from, next) => {
	to = to || {};
	//把当前页面数据缓存下来
	let curPage = {
		meta: to.meta,
		name: to.name,
		path: to.path,
		params: to.params,
		query: to.query
	};

	for (let key in sources) {
		sources[key].cancel();
		delete sources[key];
	}
	sessionStorage.setItem("_curPage", JSON.stringify(curPage));
	// if (window.qt) {
	// 	next()
	// } else {
	// 	window.location.href = config.serverUrl + '/404.html'
	// }
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js